<!-- eslint-disable @angular-eslint/template/elements-content -->
<div
    [ngClass]="{
        container: container === 'container',
        'container-fluid': container === 'container-fluid',
        'reservation-title-home': home
    }"
    class="g-0 mb-6 container-titles"
>
    <ng-container [ngSwitch]="home">
        <h1 *ngSwitchCase="true" class="d-xs-block d-inline-block">
            {{ 'fe_core_search_reservation_h1_title_home' | translate }}
        </h1>
        <h4 *ngSwitchCase="false" class="d-xs-block d-inline-block">
            {{ 'fe_core_search_reservation_h1_title' | translate }}
        </h4>
    </ng-container>
    <p class="d-xs-block d-inline-block">
        {{ 'fe_core_search_reservation_p_instructions' | translate }}
    </p>
    <fe-button
        *ngIf="
            showViewCancel &&
            configuration.featuresFlags.value?.viewCancelReservation === true
        "
        class="d-md-block d-inline-block float-md-end me-md-0 me-sm-8 me-8 btn-view-cancel-reservation"
        [style]="'link'"
        [href]="'check-your-reservation' | formatUrl"
        >{{
            'fe_core_search_reservation_a_view-cancel-reservation' | translate
        }}</fe-button
    >
</div>
<div
    [ngClass]="{
        'container-form-small': isSmall,
        container: container === 'container',
        'container-fluid': container === 'container-fluid',
        'reservation-form-home': home
    }"
    class="container gx-3 px-3 pt-3 contenedor-inputs"
>
    <form [formGroup]="form">
        <div class="row gy-6 gx-0">
            <div class="col-12 col-md">
                <fe-input
                    #inputLocation
                    [ngClass]="
                        reservation.showDifferenteLocation
                            ? 'mb-0'
                            : 'mb-0 mb-md-6'
                    "
                    [isSelect]="true"
                    [isSelectLocations]="true"
                    [roundedLocationsPanel]="true"
                    [id]="'location'"
                    [label]="
                        'fe_core_search_reservation_label_location' | translate
                    "
                    [buttonsAfter]="[]"
                    (search)="onSearchLocations($event)"
                    [groupBy]="'group'"
                    [items]="reservation.locations"
                    [selectType]="'typing'"
                    (change)="onChangeLocation()"
                    [(ngModel)]="reservation.current.location"
                    [tabIndex]="'1000'"
                    [formControlName]="'location'"
                    [textNotFound]="textNotFoundLocations"
                    [loading]="loadingLocations"
                    [customSelectSearchFn]="false"
                ></fe-input>
            </div>
            <div
                class="col-12 col-md-auto ms-md-2 col-different-location-btn"
            >
                <fe-button
                    [style]="'secondary'"
                    [btnClass]="
                        'btn-different-location-input ' +
                        (reservation.showDifferenteLocation
                            ? 'btn-different-location-input-show'
                            : '')
                    "
                    [icon]="
                        reservation.showDifferenteLocation
                            ? 'circle_eliminar'
                            : home && breakpoint.isMobile()
                              ? 'sort_yellow'
                              : 'sort'
                    "
                    (onClick)="onClickBtnAfter($event)"
                    >{{
                        'fe_core_search_reservation_btn_back-location'
                            | translate
                    }}</fe-button
                >
            </div>
            <div
                *ngIf="reservation.showDifferenteLocation"
                class="col-12 col-different-location-input"
            >
                <fe-input
                    #inputDifferentLocation
                    class="mb-0"
                    [ngClass]="{
                        'mb-md-6': form.errors === null
                    }"
                    [isSelect]="true"
                    [isSelectLocations]="true"
                    [id]="'differentLocation'"
                    [label]="
                        'fe_core_search_reservation_label_different-location'
                            | translate
                    "
                    [buttonsAfter]="[]"
                    (search)="onSearchDifferentLocations($event)"
                    [groupBy]="'group'"
                    [items]="reservation.differentLocations"
                    [selectType]="'typing'"
                    (change)="onChangeLocation()"
                    [formControlName]="'differentLocation'"
                    [(ngModel)]="reservation.current.differentLocation"
                    [tabIndex]="'1001'"
                    [textNotFound]="textNotFoundDifferentLocations"
                    [loading]="loadingDifferentLocations"
                    [customSelectSearchFn]="false"
                ></fe-input>
                <fe-form-control-feedback
                    [renderComponentInvalid]="true"
                    [errors]="
                        form.hasError('matched')
                            ? { matched: form.getError('matched') }
                            : []
                    "
                ></fe-form-control-feedback>
            </div>
        </div>
        <div
            [ngClass]="{
                'mt-md-6': form.hasError('matched'),
                'reservation-fields-home': home
            }"
            class="row gx-2"
        >
            <div
                [ngClass]="{
                    'col-6': isNormal || isSmall,
                    'col-lmd': isNormal,
                    'col-xl-3': isSmall
                }"
            >
                <fe-input
                    #inputStartDate
                    [ngClass]="{
                        'mb-6':
                            !form.hasError('differenceDatesOut') &&
                            !form.hasError('differenceDatesIn')
                    }"
                    [id]="'startDate'"
                    [label]="
                        'fe_core_search_reservation_label_start-date'
                            | translate
                    "
                    [formatDate]="inputDatePickerFormat"
                    [setDateRange]="'start'"
                    [isRangeDate]="true"
                    [mask]="'00/00/0000'"
                    [startDate]="startDate"
                    [endDate]="endDate"
                    [fromDate]="fromDate"
                    [toDate]="toDate"
                    (fromDateChange)="onFromDateChange($event)"
                    (isSelectingChange)="isSelectingChange($event)"
                    [(ngModel)]="reservation.current.startDate"
                    [formControlName]="'startDate'"
                    [tabIndex]="'1002'"
                    [disabled]="!form.get('location')?.valid"
                ></fe-input>
                <fe-form-control-feedback
                    [flowPage]="'step1'"
                    [ngClass]="{
                        'mb-6':
                            form.hasError('differenceDatesOut') ||
                            form.hasError('differenceDatesIn')
                    }"
                    class="d-flex"
                    [renderComponentInvalid]="true"
                    [errors]="
                        form.hasError('differenceDatesOut')
                            ? {
                                  differenceDatesOut:
                                      form.getError('differenceDatesOut')
                              }
                            : form.hasError('differenceDatesIn')
                              ? {
                                    differenceDatesIn:
                                        form.getError('differenceDatesIn')
                                }
                              : []
                    "
                ></fe-form-control-feedback>
            </div>
            <div
                [ngClass]="{
                    'col-6': isNormal || isSmall,
                    'col-lmd': isNormal,
                    'col-xl-3': isSmall
                }"
            >
                <fe-input
                    #inputStartHour
                    class="mb-6"
                    [isSelect]="true"
                    [id]="'name'"
                    [label]="
                        'fe_core_search_reservation_label_start-hour'
                            | translate
                    "
                    [items]="reservation.startHours"
                    [(ngModel)]="reservation.current.startHour"
                    [formControlName]="'startHour'"
                    [tabIndex]="'1003'"
                    [loading]="loadingStartHours"
                    (ngModelChange)="onFromHourChange()"
                    [disabled]="
                        !form.get('startDate')?.valid ||
                        reservation.startHours.length === 0
                    "
                ></fe-input>
                <fe-form-control-feedback
                    [flowPage]="'step1'"
                    class="d-flex"
                    [renderComponentInvalid]="true"
                    [errors]="
                        startHourUnavailable ? { hourUnavailable: true } : []
                    "
                ></fe-form-control-feedback>
            </div>
            <div
                [ngClass]="{
                    'col-6': isNormal || isSmall,
                    'col-lmd': isNormal,
                    'col-xl-3': isSmall
                }"
            >
                <fe-input
                    #inputEndDate
                    class="mb-6"
                    [isSelect]="false"
                    [id]="'endDate'"
                    [label]="
                        'fe_core_search_reservation_label_end-date' | translate
                    "
                    [formatDate]="inputDatePickerFormat"
                    [setDateRange]="'end'"
                    [isRangeDate]="true"
                    [mask]="'00/00/0000'"
                    [startDate]="startDate"
                    [endDate]="endDate"
                    [fromDate]="fromDate"
                    (toDateChange)="onToDateChange($event)"
                    (isSelectingChange)="isSelectingChange($event)"
                    [(ngModel)]="reservation.current.endDate"
                    [formControlName]="'endDate'"
                    [tabIndex]="'1004'"
                    [disabled]="!form.get('startHour')?.valid"
                ></fe-input>
            </div>
            <div
                [ngClass]="{
                    'col-6': isNormal || isSmall,
                    'col-lmd': isNormal,
                    'col-xl-3': isSmall
                }"
            >
                <fe-input
                    #inputEndHour
                    [ngClass]="{ 'mb-6': !form.hasError('lessThanDate') }"
                    [isSelect]="true"
                    [id]="'name'"
                    [label]="
                        'fe_core_search_reservation_label_end-hour' | translate
                    "
                    [items]="reservation.endHours"
                    [(ngModel)]="reservation.current.endHour"
                    [tabIndex]="'1005'"
                    [formControlName]="'endHour'"
                    [loading]="loadingEndHours"
                    (ngModelChange)="onToHourChange()"
                    [disabled]="
                        !form.get('endDate')?.valid ||
                        reservation.endHours.length === 0
                    "
                ></fe-input>
                <fe-form-control-feedback
                    [flowPage]="'step1'"
                    [ngClass]="{
                        'mb-6': form.hasError('lessThanDate')
                    }"
                    class="d-flex"
                    [renderComponentInvalid]="true"
                    [errors]="
                        form.hasError('lessThanDate')
                            ? {
                                  lessThanDate: form.getError('lessThanDate')
                              }
                            : endHourUnavailable
                              ? { hourUnavailable: true }
                              : []
                    "
                ></fe-form-control-feedback>
            </div>
            <div
                [ngClass]="{
                    'col-md-4': isNormal,
                    'col-sm-4': isNormal,
                    'col-lmd-2': isNormal,
                    'col-sm-6': isSmall
                }"
                class="col-12"
            >
                <fe-input
                    #inputAge
                    class="mb-6"
                    [isSelect]="true"
                    [id]="'age'"
                    [label]="'fe_core_search_reservation_label_age' | translate"
                    [items]="[
                        {
                            id: 21,
                            name: '21'
                        },
                        {
                            id: 22,
                            name: '22'
                        },
                        {
                            id: 23,
                            name: '23'
                        },
                        {
                            id: 24,
                            name: '24'
                        },
                        {
                            id: 25,
                            name: '25+'
                        }
                    ]"
                    [(ngModel)]="reservation.current.age"
                    [tabIndex]="'1006'"
                    [formControlName]="'age'"
                ></fe-input>
            </div>
            <div *ngIf="isNormal && !home" class="w-100 d-none d-lmd-block"></div>
            <div
                [ngClass]="{
                    'col-md-4': isNormal,
                    'col-sm-4': isNormal,
                    'col-lmd-3': isNormal,
                    'col-sm-6': isSmall
                }"
                *ngIf="showCouponInput"
                class="col-12"
            >
                <fe-input
                    #inputDiscountCode
                    class="mb-6"
                    [id]="'discount'"
                    [label]="
                        'fe_core_search_reservation_label_discount-code'
                            | translate
                    "
                    [(ngModel)]="reservation.current.discountCode"
                    [ngModelOptions]="{ standalone: true }"
                    [tabIndex]="'1006'"
                ></fe-input>
            </div>
            <div
                [ngClass]="{
                    'col-lmd-auto': isNormal,
                    'col-md-3': isNormal,
                    'col-sm-4': isNormal,
                    'col-xs-auto': isNormal
                }"
                class="col-12"
            >
                <fe-button
                    class="d-grid mb-sm-0 mb-6 btn-search-reservation"
                    [btnClass]="'px-9'"
                    [style]="'primary'"
                    [type]="'button'"
                    [loading]="loadingBtnSearch"
                    (onClick)="onClickSearch()"
                    [tabIndex]="'1007'"
                    [disabled]="
                        configuration.featuresFlags.value?.reservation !==
                            true || hasBlockingError
                    "
                >
                    {{ 'fe_core_search_reservation_button_search' | translate }}
                </fe-button>
            </div>
        </div>
        <div class="row mt-6">
            <div
                class="col-12 mb-21 fw-bold d-flex align-items-center container-link-business"
            >
                {{
                    'fe_core_search_reservation_text_bussines-trip' | translate
                }}
                <fe-button
                    [style]="'link'"
                    [btnClass]="'p-0 fw-bold'"
                    [href]="'corporate' | formatUrl"
                    [title]="'fe_menu_empresas_link' | translate"
                    >{{
                        'fe_core_search_reservation_text_here' | translate
                    }}</fe-button
                >
            </div>
        </div>
    </form>
</div>
